import http from '@/axios/http'

const post = ({ headers, data, url }) => {
  headers = {
    'Content-Type': 'application/json',
    ...headers
  }
  if (localStorage.getItem('token')) {
    headers.Auth = localStorage.getItem('token')
  }

  return http
    .post(
      url,
      data,
      { headers }
    )
    .then(response => response.data)
}

export const createEvent = (info) => {
  return post({
    url: '/create_event',
    data: { ...info }
  })
}

export const updateEvent = (info) => {
  return post({
    url: '/update_event',
    data: { ...info }
  })
}

// exclusao do evento (so Admin; o backend exige o nome exato em `confirm`)
export const deleteEvent = (info) => {
  return post({
    url: '/delete_event',
    data: { ...info }
  })
}

export const setImage = (info) => {
  return post({
    url: '/set_event_image',
    data: { ...info }
  })
}

export const getImage = (info) => {
  return post({
    url: '/get_event_image',
    data: { ...info }
  })
}

// Duração estimada da competição (só Admin/Organizador; o backend faz o gate).
export const getDuration = (info) => {
  return post({
    url: '/get_event_duration',
    data: { ...info }
  })
}
